export default __webpack_public_path__ + "static/media/0thMeltozx3.364c5314.gif";